import React, {useEffect, useState} from "react";
import {notification, Pagination} from "antd";
import Spinner from "../../../spinner";
import {companyService, userServices, distributionCenterService} from "../../../../services";
import CarrierCompanyCard from "./carrier-company-card";
import {companiesConfig} from "../../../../config";
import FiltersForConsignor from "./filters";
import {ACCOUNTANT_LEGAL_ENTITY_APPROVE, LAWYER_LEGAL_ENTITY_APPROVE} from "../../../../helpers/user_permission.helper";
import i18n from "../../../../i18n";

export default function CompaniesList({consignorSettings}) {
  const user = userServices.getUser();

  const [loading, setLoading] = useState(true);
  const [isNeedUpdate, setIsNeedUpdate] = useState(true);
  const [stopListUpdate, setStopListUpdate] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [step, setStep] = useState(companiesConfig.pageCount);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [listCompanies, setListCompanies] = useState([]);
  const [shipperCompanies, setShipperCompanies] = useState([]);
  const [distributionCentersList, setDistributionCentersList] = useState([]);

  const [counts, setCounts] = useState({
    approveOrdersCount: 0,
    contractOrdersCount: 0
  })

  let initLegalEntityApproveStatus = (user.isAccessTo(LAWYER_LEGAL_ENTITY_APPROVE) || user.isAccessTo(ACCOUNTANT_LEGAL_ENTITY_APPROVE)) ? [1] : [];
  let initMyAcces = (user.isAccessTo(LAWYER_LEGAL_ENTITY_APPROVE) || user.isAccessTo(ACCOUNTANT_LEGAL_ENTITY_APPROVE)) ? true : false;


  const [filterParams, setFilterParams] = useState({
    legalNumber: null,
    username: null,
    name: null,
    webid: null,
    legalEntityApproveStatuses: initLegalEntityApproveStatus,
    contractApproveStatuses: [],
    agreedContractByShipperCompanies: [],
    distributionCenterId: [],
    haveDelivDelay: false,
    minDelivDelay: null,
    maxDelivDelay: null,
    haveAccreditation: false,
    myAccess: initMyAcces,
    needApproveGosLog: false,
    consignorID: null,
    limit: step,
    offset: offset,
    noCompanyTypes: [4],
  });

  useEffect(() => {
    if (isNeedUpdate) {
      getNewOrdersCount();
      getShipperCompanyList();
      getDistributionCentersList();
      getList();
    }
  }, [isNeedUpdate]);

  const getList = () => {
    setLoading(true);
    companyService.getListForConsignor(filterParams)
      .then(resp => {
        setListCompanies(resp.data);
        setIsNeedUpdate(false);
        setLoading(false);
        setTotalCount(resp.totalCount);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.getListForConsignor'),
          description: err,
        });
      });
  };

  const getShipperCompanyList = () => {
    companyService.getShipperCompanyList()
      .then(resp => {
        setShipperCompanies(resp);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.getShipperCompanyList'),
          description: err,
        });
      });
  };

  const getDistributionCentersList = () => {
    distributionCenterService.getCompanies()
      .then((response) => {
          setDistributionCentersList(response);
      })
      .catch((err) => {
          notification.error({
              message: i18n.t('components.notification.titles.getCompanies2'),
              description: err,
          });
      });
  };
  const queryParams = {
    noCompanyType: 4
  };
  const getNewOrdersCount = () => {
    companyService.getNewOrdersCount(queryParams)
      .then(resp => {
        setCounts(resp);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.getNewOrdersCount'),
          description: err,
        });
      });
  }

  let onChange = (page, pageSize) => {
    if (page === currentPage) {
      return false;
    } else {
      setCurrentPage(page);
    }

    let val = 0;
    if (parseInt(page) === 1) {
      setOffset(0);
      setFilterParams({...filterParams, offset: 0})
    } else {
      val = page * pageSize - pageSize;
      setFilterParams({...filterParams, offset: val})
      setOffset(val);
    }

    setIsNeedUpdate(true);
  };

  return (
    <>
      <h1 className="content-header">{i18n.t('consignorPage.companiesList.title')}</h1>
      <FiltersForConsignor filterParams={filterParams} setCurrentPage={setCurrentPage} counts={counts} isNeedUpdate={isNeedUpdate} shipperCompanies={shipperCompanies} distributionCentersList={distributionCentersList} setFilterParams={setFilterParams} setIsNeedUpdate={setIsNeedUpdate} userRole={user.info.role}/>
      <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
        {listCompanies && listCompanies.length !== 0 ?
          <div className="application-block pagination">
            <Pagination
              style={{textAlign: "center", marginBottom: "20px"}}
              current={currentPage}
              pageSize={step}
              total={totalCount}
              showTotal={(total, range) => `${range[0]}-${range[1]} ${i18n.t('components.pagination.of')} ${totalCount}`}
              onChange={onChange}
            />
          </div>
          : null}
        {listCompanies.map((item) =>
          <CarrierCompanyCard company={item} key={item.legalEntityID} consignorSettings={consignorSettings} setIsNeedUpdate={setIsNeedUpdate} setStopListUpdate={setStopListUpdate}/>
        )}
        {listCompanies && listCompanies.length !== 0 ?
          <div className="application-block pagination">
            <Pagination
              style={{textAlign: "center", paddingBottom: 0}}
              current={currentPage}
              pageSize={step}
              total={totalCount}
              showTotal={(total, range) => `${range[0]}-${range[1]} ${i18n.t('components.pagination.of')} ${totalCount}`}
              onChange={onChange}
            />
          </div>
          : null}
      </Spinner>
    </>
  );
}
